import * as React from 'react';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import MultiSelectOTA from '~/features/base/components/forms/ota/MultiselectOTA';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';
import { useLazyFetchDeliverableVersionsQuery } from '~/api/deliverables/DeliverablesManagement.api';
import { DeliverableSearchCriteriaDeliverableTypeEnum } from '~/api/models/deliverable-search-criteria';
import { UNKNOWN } from '~/features/base/constants/filterOptions';

interface DistroFormItemProps {
    value: string[];
    onChange: (versions: string[]) => void;
}
const DISTRO_ID = 'distro'
const DistroFormItem = ({ value, onChange }: DistroFormItemProps) => {
    const intl = useIntl();

    const [distroVersions, setDistroVersions] = useState<{
        label: string | React.JSX.Element,
        value?: string,
        id: string
    }[]>();

    const [getDeliverableVersions] = useLazyFetchDeliverableVersionsQuery();

    useEffect(() => {
        getVersions(DISTRO_ID, DeliverableSearchCriteriaDeliverableTypeEnum.DISTRO);
    }, []);

    const getVersions = (deliverableId = '', deliverableType = '') => {
        getDeliverableVersions({ deliverableId, deliverableType }, true).then(result => {
            const versionsList = result?.data?.content.map(version => {
                return {
                    label: toShortSemanticVersion(version),
                    value: toShortSemanticVersion(version),
                    id: toShortSemanticVersion(version)
                };

            });
            versionsList && setDistroVersions([{
                label: UNKNOWN,
                value: UNKNOWN,
                id: UNKNOWN
            }, ...versionsList]);

        });
    };

    const handleOnchange = (versions) => {
        onChange(versions || []);
    };

    return (
        <div className='form-group'>
            <MultiSelectOTA
                labelId='intl-msg:distroVersion'
                options={distroVersions?.map(v => v.value) || []}
                value={value || []}
                onChange={handleOnchange}/>
        </div>
    );
};

export default DistroFormItem;
